import React from 'react';
import style from './passwordInputWithValidation.module.scss';
import { InputWithValidation, InputWithValidationProps } from 'acscp/components/common/validation/inputWithValidation';
import classNames from 'classnames';

interface PasswordInputWithValidationState {
    passwordIsVisible: boolean;
}

class PasswordInputWithValidation extends React.Component<InputWithValidationProps, PasswordInputWithValidationState> {
    constructor(props: InputWithValidationProps) {
        super(props);
        this.state = {passwordIsVisible: false};
    }

    showPassword = (event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) =>
        this.setState({ passwordIsVisible: true})

    hidePassword = (event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) =>
        this.setState({ passwordIsVisible: false})

    render(): JSX.Element {
        return (
            <div className={style.PasswordContainer}>
                <InputWithValidation
                    type={this.state.passwordIsVisible ? 'text' : 'password'}
                    {...this.props}
                />
                <div
                    className={classNames(style.PasswordReveal,
                        {[style.PasswordReveal_Shown]: this.state.passwordIsVisible})}
                    onMouseDown={this.showPassword}
                    onMouseUp={this.hidePassword}
                    onMouseLeave={this.hidePassword}
                    onTouchStart={this.showPassword}
                    onTouchEnd={this.hidePassword}
                />
            </div>
        );
    }
}
export { PasswordInputWithValidation };
